import { render } from "./Quotation3.vue?vue&type=template&id=0b4062ea"
import script from "./Quotation3.vue?vue&type=script&lang=js"
export * from "./Quotation3.vue?vue&type=script&lang=js"
script.render = render

export default script